import '../../style/login/style-app-login.scss'
import CtaButton from '../../components/ctaButton/CtaButton'
import { useState } from 'react'
import { PAGE_URLS } from '../../constants/hrefLinks'
// import { useCookies } from 'react-cookie'
// import { userStateData } from '../../data/userStateData'
import { PASSWORD_NUMBERS_CHARS, PASSWORD_SPECIAL_CHARS } from '../../constants/sharedConstants'
import { registerConnector } from '../../server/connector/registerConnector'

function AppSignUp() {

	const [firstName, setFirstName] = useState<string>('')
	const [email, setEmail] = useState<string>('')
	const [password, setPassword] = useState<string>('')
	const [passwordUpdated, setPasswordUpdated] = useState<boolean>(false)

	const [signingUp, setSigningUp] = useState<boolean>(false)
	const [signUpFailed, setSignUpFailed] = useState<boolean>(false)
	const [signUpSuccess, setSignUpSuccess] = useState<boolean>(false)

	// const [cookies, setCookie] = useCookies(['userData'])

	const [passwordContainsSpecialChars, setPasswordContainsSpecialChars] = useState<boolean>(false)
	const [passwordContainsDigit, setPasswordContainsDigit] = useState<boolean>(false)
	const [passwordLongEnough, setPasswordLongEnough] = useState<boolean>(false)

	const signUpClicked = () => {
		setSigningUp(true)
		registerConnector.performAppRegisterRequest(firstName, email, password).then((successRequest) => {
			if (!successRequest) {
				setSignUpFailed(true)
				setSigningUp(false)
			} else {
				setSignUpSuccess(true)
				setSigningUp(false)
				// TEMP: redirect to log in for new customer who doesn't need to wait for email
				window.location.replace(PAGE_URLS.APP_LOGIN)
			}
		})
	}

	const passwordChangeHandler = (newValue: string) => {
		let containsSpecialChar: boolean = false
		PASSWORD_SPECIAL_CHARS.split('').forEach((char: string) => {
			if (newValue.includes(char)) {
				containsSpecialChar = true
			}
		})
		setPasswordContainsSpecialChars(containsSpecialChar)
		let containsNumber: boolean = false
		PASSWORD_NUMBERS_CHARS.split('').forEach((char: string) => {
			if (newValue.includes(char)) {
				containsNumber = true
			}
		})
		setPasswordContainsDigit(containsNumber)
		setPasswordLongEnough(newValue.length > 7)
		setPassword(newValue)
	}
	
	return (
		<>
			<div className='section-wrap'>
				<div className='section-content'>
					<div className='log-in-content'>
						<div className='log-in-content-section'>
							<div className='log-in-form'>
								<div className='log-in-form-title'>Sign up to Peyto</div>
								{signUpSuccess ? 
									<div className='log-in-form-label-txt'>
										Sign Up Complete, Please verify your email using the link sent to your email
									</div>
									:
									<>
										<input 
											className='log-in-form-input' 
											placeholder={'Full Name'} 
											value={firstName}
											onChange={(event) => {
												setFirstName(event.target.value)
											}}
											disabled={signingUp}
										/>
										<input 
											className='log-in-form-input' 
											type={'email'} 
											placeholder={'Email'} 
											value={email}
											onChange={(event) => {
												setEmail(event.target.value)
											}}
											disabled={signingUp}
										/>
										<input 
											className={`${(passwordContainsSpecialChars === false || passwordContainsDigit === false || passwordLongEnough === false) && password.length > 0 ? 'log-in-form-input log-in-form-input-red' : 'log-in-form-input'}`}
											placeholder={'Password'} 
											value={password}
											onChange={(event) => {
												passwordChangeHandler(event.target.value)
											}}
											onBlur={() => {
												setPasswordUpdated(true)
											}}
											type='password'
											disabled={signingUp}
										/>
										{passwordUpdated === true && passwordContainsSpecialChars === false && <div className='log-in-form-requirement-txt'>Must contain special character</div>}
										{passwordUpdated === true && passwordContainsDigit === false && <div className='log-in-form-requirement-txt'>Must contain a digit</div>}
										{passwordUpdated === true && passwordLongEnough === false && <div className='log-in-form-requirement-txt'>Must be at least 8 characters long</div>}
										{signUpFailed && <div className='log-in-form-login-failed'>
											Sign up Failed, email may already be registered
										</div>}
										<div className='log-in-form-sub-text'>By signing up for Peyto, you agree to our <a>Terms and Conditions.</a> View out <a>Privacy Policy.</a></div>
										<CtaButton
											label={signingUp ? 'Signing Up...' : 'Sign Up'}
											size='medium'
											onClick={() => signUpClicked()}
											fullWidth={true}
											disabled={
												firstName === '' ||
												email === '' ||
												password === '' ||
												passwordContainsSpecialChars === false ||
												passwordContainsDigit === false ||
												passwordLongEnough === false ||
												signingUp
											}
										/>
										<div className='log-in-line-text-span-wrap'>
											<div className='log-in-line-text-span-wrap-span'>or</div>
										</div>
										<div className='log-in-already-have-account'>Already have an account? <a href={PAGE_URLS.APP_LOGIN}>Log In</a></div>
									</>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default AppSignUp
